import React from 'react';
import { motion } from 'framer-motion';
import { ListChecks, Hammer, Home, Video, PlayCircle, Users, Headphones, RefreshCw, Tag } from 'lucide-react';
const blocks = [{
  icon: ListChecks,
  title: 'Estructura clara',
  desc: 'Paso a paso, sin saltos. Sabés exactamente dónde estás.'
}, {
  icon: Hammer,
  title: '100% Práctico',
  desc: 'Aprendé haciendo. Cada concepto se aplica.'
}, {
  icon: Home,
  title: 'Aplicado a viviendas',
  desc: 'Casos reales de instalaciones residenciales.'
}, {
  icon: Video,
  title: 'Clases en vivo',
  desc: 'Con docente real que responde tus dudas.'
}, {
  icon: PlayCircle,
  title: 'Clases grabadas',
  desc: 'Miralas cuando quieras y las veces que necesites.'
}, {
  icon: Users,
  title: 'Comunidad activa',
  desc: 'Aprendé acompañado de otros alumnos.'
}, {
  icon: Headphones,
  title: 'Soporte y consultas',
  desc: 'No estás solo. Ayuda real durante todo el proceso.'
}, {
  icon: RefreshCw,
  title: 'Actualizaciones',
  desc: 'Contenido siempre vigente. Sumás sin pagar de nuevo.'
}, {
  icon: Tag,
  title: 'Descuentos futuros',
  desc: 'Beneficios exclusivos para alumnos de la academia.'
}];
export function WhyAcademy() {
  return <section id="academia" className="py-24 bg-ed-black relative border-t border-white/5 overflow-hidden" data-id="element-557">
      <div className="absolute inset-0 bg-radial-green-center opacity-20 pointer-events-none" data-id="element-558"></div>
      <div className="absolute inset-0 bg-grid-pattern opacity-10 pointer-events-none" data-id="element-559"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-560">
        <div className="text-center mb-14 max-w-3xl mx-auto" data-id="element-561">
          <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-562">
            La diferencia
          </span>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white leading-[1.05]" data-id="element-563">
            No es solo un curso. <br data-id="element-564" />
            Es una <span className="text-ed-green" data-id="element-565">academia.</span>
          </h2>
          <p className="text-zinc-400 text-lg mt-6" data-id="element-566">
            Una estructura de formación profesional completa. Todo lo que
            necesitás para dominar el oficio de verdad.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-567">
          {blocks.map((b, i) => {
          const Icon = b.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: i * 0.06
          }} className="bg-ed-dark border border-zinc-800 rounded-2xl p-6 hover:border-ed-green/40 transition-all group relative overflow-hidden" data-id="element-568">
                <div className="absolute -top-16 -right-16 w-32 h-32 bg-ed-green/5 blur-2xl rounded-full pointer-events-none group-hover:bg-ed-green/15 transition-colors" data-id="element-569"></div>

                <div className="relative z-10" data-id="element-570">
                  <div className="w-12 h-12 rounded-xl bg-ed-green/10 border border-ed-green/30 flex items-center justify-center mb-4 group-hover:glow-green-sm transition-all" data-id="element-571">
                    <Icon className="w-5 h-5 text-ed-green" data-id="element-572" />
                  </div>
                  <h3 className="text-white font-black uppercase text-base tracking-wide mb-2 leading-tight" data-id="element-573">
                    {b.title}
                  </h3>
                  <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-574">
                    {b.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}